import Login from './login';
import Admin from './admin';
import Password from './password';

const routes = [
  {
    path: '/',
    component: Login,
    exact: true,
  },
  {
    path: '/login',
    component: Login,
    exact: true,
  },
  {
    path: '/password',
    component: Password,
  },
  {
    path: '/admin',
    component: Admin,
  },
];

export default routes;
